import { analytics } from './analytics'
import { errands } from './errands'
import { Feature } from '../pinia/feature'
import { info } from './info'
import { wip } from './wip'
import { files } from './files'
import { ibinder } from './ibinder'
import { entities } from './entities'
import { assets } from './assets'
import { rentalObjects } from './rental-objects'

const features: Feature = {
  name: 'digital-buildings',
  enabled: true,
  title: {
    en: 'Digital Buildings',
    sv: 'Digital Buildings'
  },
  children: [info, entities, files, ibinder, errands, assets, rentalObjects, analytics, wip]
}

export default features
